export default __webpack_public_path__ + "static/media/include_8_female@2x.d2213d11.jpg";